import * as questionIds from "../../consultationQuestions/questionIds";

export const biologicalMonitoringQuestions = [
    {
        id: questionIds.BiologicalMonitoringUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.BiologicalMonitoringUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.BiologicalMonitoringSampleTaken,
        questionText: "Type of Sample taken",
    },
    {
        id: questionIds.BiologicalMonitoringSampleTakenOtherDetails,
        questionText: "Give details",
    },
    {
        id: questionIds.BiologicalMonitoringSubstancesBeingTestedFor,
        questionText: "Details of substance(s) being tested for",
    },
    {
        id: questionIds.BiologicalMonitoringLaboratorySentTo,
        questionText: "Details of Laboratory the sample has been sent to",
    },
    {
        id: questionIds.BiologicalMonitoringClinicalNotes,
        questionText: "Clinical Notes",
    },
];
